export default __webpack_public_path__ + "static/media/icon-coursereviewinactive.498ac9a7.svg";